import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	GammaPetitionPageVideos,
	type GammaPetitionPageVideosQuery,
	type GammaPetitionPageVideosQueryVariables,
} from './api.graphql';

export type SupporterVoicesVideos = {
	enabled: boolean;
	videos: GammaPetitionPageVideosQuery['petitionVideosConnection']['nodes'];
};

export const getSupporterVoicesVideos = async (
	utilityContext: UtilityContext,
	slugOrId: string,
	disableDisplay: boolean,
): Promise<SupporterVoicesVideos> => {
	/**
	 * Moderation staff can disable display of videos using petition metadata, in which case we
	 * should not fetch them at all.
	 */
	if (disableDisplay) {
		return {
			enabled: false,
			videos: [],
		};
	}

	const { data } = await utilityContext.gql.fetch<GammaPetitionPageVideosQuery, GammaPetitionPageVideosQueryVariables>({
		query: GammaPetitionPageVideos,
		variables: {
			petitionSlugOrId: slugOrId,
			first: 10,
			sortBy: 'SCORE',
		},
		rejectOnError: false,
		batched: true,
	});

	return {
		enabled: true,
		videos: data?.petitionVideosConnection.nodes ?? [],
	};
};
